import { Injectable } from '@angular/core';
import { Body, HttpService, Post } from '@rfx/ngx-http';
import { Observable } from 'rxjs';
import { LogCreateDto } from '../models';

@Injectable({
    providedIn: 'root'
})
export class LogService extends HttpService {
    @Post('/log/create')
    // NOTE I am unsure why when 'data' is typed as LogCreateDto, all data is stripped from the request body
    // even though I've confirmed that the data structure and types of the request data matches that of the LogCreateDto
    public createLog(@Body() data: any): Observable<void> {
        return null;
    }
}
